import PropTypes from 'prop-types';
import {errorIfMissingRequired, errorIfNoInput} from "./definition.errorcheck";
import {translateObjectArray} from "./definitions.arrayparse";

const SharedUser = class {
  static propTypes = {
    guid: PropTypes.string.isRequired,
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    street: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
    phone: PropTypes.string,
    memberGuid: PropTypes.string,
    memberFirstName: PropTypes.string,
    memberLastName: PropTypes.string,
    companyGuid: PropTypes.string,
    sharedByMember: PropTypes.string,
    viewPrivilege: PropTypes.bool,
    printPrivilege: PropTypes.bool,
    downloadPrivilege: PropTypes.bool,
    expires: PropTypes.string,
    started: PropTypes.string,
    doesNotExpire: PropTypes.bool,
    active: PropTypes.bool,
    expiresDays: PropTypes.number,
    sharedDocumentCount: PropTypes.number,
    accessExpired: PropTypes.bool
  }

  constructor(guid, email, firstName, lastName, street, city, state, zipCode, phone, memberGuid, memberFirstName, memberLastName, companyGuid,
              sharedByMember, viewPrivilege, printPrivilege, downloadPrivilege, expires, started, doesNotExpire,
              active, expiresDays, sharedDocumentCount, accessExpired) {
    this.guid = guid;
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.street = street;
    this.city = city;
    this.state = state;
    this.zipCode = zipCode;
    this.phone = phone;
    this.memberGuid = memberGuid;
    this.memberLastName = memberLastName;
    this.memberFirstName= memberFirstName;
    this.companyGuid = companyGuid;
    this.sharedByMember = sharedByMember;
    this.viewPrivilege = viewPrivilege;
    this.printPrivilege = printPrivilege;
    this.downloadPrivilege = downloadPrivilege;
    this.expires = expires;
    this.started = started;
    this.doesNotExpire = doesNotExpire;
    this.active = active;
    this.expiresDays = expiresDays;
    this.sharedDocumentCount = sharedDocumentCount;
    this.accessExpired = accessExpired;
  }

  /**
   *
   * @param {{guid: string, email: string, firstName: string, lastName: string, street: string, city: string, state: string, zipCode: string, phone: string, memberGuid: string, memberFirstName: string, memberLastName: string, companyGuid: string, sharedByMember: string, viewPrivilege: bool, printPrivilege: bool, downloadPrivilege: bool, expires: string, started: string, doesNotExpire: bool, active: bool, expiresDays: number, sharedDocumentCount: number, accessExpired: bool }} object
   * @returns {SharedUser}
   */
  static translateObject(object) {
    errorIfNoInput(object);
    const requiredFields = {
      guid: object.guid
    }
    errorIfMissingRequired(requiredFields);

    return new SharedUser(object.guid, object.email, object.firstName, object.lastName,
      object.street, object.city, object.state, object.zipCode, object.phone,
      object.memberGuid, object.memberFirstName, object.memberLastName, object.companyGuid, object.sharedByMember,
      object.viewPrivilege, object.printPrivilege, object.downloadPrivilege,
      object.expires, object.started, object.doesNotExpire, object.active,
      object.expiresDays, object.sharedDocumentCount, object.accessExpired);
  }

  /**
   *
   * @param {{guid: string, email: string, firstName: string, lastName: string, street: string, city: string, state: string, zipCode: string, phone: string, memberGuid: string, memberFirstName: string, memberLastName: string, companyGuid: string, sharedByMember: string, viewPrivilege: bool, printPrivilege: bool, downloadPrivilege: bool, expires: string, started: string, doesNotExpire: bool, active: bool, expiresDays: number, sharedDocumentCount: number, accessExpired: bool }[]} array
   * @returns {SharedUser[]}
   */
  static translateObjectArray(array) {
    return translateObjectArray(array, this.translateObject);
  }
}

export default SharedUser;
